export const MuiInputBaseStyle = {
    styleOverrides: {
        root: {
            padding: 0,
        },
    },
};
